<template>
  <div class="article">
    <div class="title">香港晴天集团董事局主席洪子晴爵士Lady Athena Hung应邀出席世界华商周（迪拜）暨第二届双湾论坛</div>
    <div class="info">作者：晴天集团    发布于：2025-06-03 09:48:44</div>
    <p>香港晴天集团董事局主席洪子晴爵士Lady Athena Hung应邀出席世界华商周（迪拜）暨第二届双湾论坛 <br>Lady Athena Hung, Chairman of the Board of Hong Kong HCC Group, was invited to attend the World Chinese Entrepreneurs Week (Dubai) and the Second Double Bay Forum.</p>
    <p>2024年11月13-14日在中国驻阿联酋使领馆的指导与支持下，由阿联酋中华工商总会主办，在迪拜盛大举行以“未来世界，华商机遇”为主题的“世界华商周（迪拜）暨第二届双湾论坛”活动，大会吸引了来自全球29个国家和地区超600余位来自各个行业的企业家代表、政府官员及华商领袖出席。 <br>
    From November 13th to 14th, 2024, under the guidance and support of Chinese embassies and consulates in the UAE, the "World Chinese Entrepreneurs Week (Dubai) & 2nd Double Bay Forum" with the theme of "Future World, Opportunities for Chinese Entrepreneurs" was grandly held in Dubai. Hosted by the Chinese General Chamber of Commerce - UAE, the event attracted over 600 entrepreneur representatives, government officials, and Chinese business leaders from various industries across 29 countries and regions worldwide.</p>
    <p>本次活动汇聚了来自中阿两国的重量级嘉宾，其中包括：
      阿联酋对外贸易部部长萨尼阁下，
      阿联酋迪拜重要王室成员谢赫·穆尔亲王，
      阿联酋经济部次长阿卜杜拉，
      中国驻阿联酋大使张益明阁下，
      中国驻迪拜总领事欧渤芊阁下，
      全国政协常委、香港中华总商会主席蔡冠深博士，
      香港晴天集团有限公司董事局主席、香港中华工商总会执行主席、洪子晴慈善基金会主席、洪子晴生命科学基金主席洪子晴爵士Lady Athena Hung等重要领导。<br>
    The event brought together heavyweight guests from China and the UAE, including:
      H.E. Thani bin Ahmed Al Zeyoudi, Minister of State for Foreign Trade of the UAE
      Sheikh Mohammed bin Rashid Al Maktoum, an important member of the Dubai royal family
      Abdullah, Under-Secretary of the UAE Ministry of Economy
      H.E. Zhang Yiming, Chinese Ambassador to the UAE
      H.E. Ou Boqian, Consul General of China in Dubai
      Dr. Jonathan KS Choi, Member of the Standing Committee of the National Committee of the Chinese People's Political Consultative Conference (CPPCC) and Chairman of the Chinese General Chamber of Commerce, Hong Kong
      Lady Athena Hung, Chairman of the Board of Hong Kong HCC Group Ltd. ;Executive Chairman, Hong Kong Chinese Industry & Commerce Association; Chairman of THE HUNG CHI CHING CHARITABLE FUND ; Chairman of HUNG CHI CHING Life Science Foundation and other important leaders.  </p>
    <p>阿联酋经济部次长阿卜杜拉致辞强调双方应促进贸易、推动创新，互利共赢。中国驻迪拜总领事欧渤芊指出华商对中国发展的贡献以及全球华商与中国的同舟共济关系。全国政协常委、香港中华总商会会长、粤港澳大湾区企业家联盟主席蔡冠深提及中阿关系发展及双湾合作契机。<br> Abdullah, Under-Secretary of the UAE Ministry of Economy, emphasized in his speech the need to promote trade, drive innovation, and achieve mutual benefit and win-win results between the two sides. Ou Boqian, Consul General of China in Dubai, pointed out the contributions of Chinese entrepreneurs to China's development and the solidarity between global Chinese entrepreneurs and China through thick and thin. Dr.Jonathan Choi Koon-shum,Member of the Standing Committee of the National Committee of the Chinese People's Political Consultative Conference (CPPCC), Chairman of the Chinese General Chamber of Commerce, Hong Kong, and Chairman of the Guangdong-Hong Kong-Macao Greater Bay Area Entrepreneurs Alliance, addressed the development of China-UAE relations and the opportunities for cooperation between the two bays.</p>
    <p>香港晴天集团有限公司董事局主席、香港中华工商总会执行主席、洪子晴慈善基金会主席、洪子晴生命科学基金主席洪子晴爵士Lady Athena Hung 应邀参加本次论坛，并在分论坛“康养社会、医疗”方面与大家分享关于顺势疗法的发展与未来。<br> Chairman of the Board of  Hong Kong HCC Group Ltd.; Executive Chairman, Hong Kong Chinese Industry & Commerce Association; Chairman of THE HUNG CHI CHING CHARITABLE FUND ; Chairman of HUNG CHI CHING Life Science Foundation，Lady Athena Hung was invited to participate in this forum and shared insights on the development and future of homeopathy at the sub-forum themed "Healthy Aging Society and Healthcare". </p>
    <p>分论坛交流：分别举办数字金融、科技智造、青年教育、康养社会和地产热土分论坛，就金融、数字经济、新能源、科技、教育、医疗等领域展开交流，共同探讨了中阿经济、双湾经济合作的未来发展.此次活动不仅是全球华商交流与合作的重要平台，也标志着中阿经济、文化合作的进一步深化。<br> Sub-forum Exchanges: Sub-forums were held on Digital Finance, Technology-Driven Smart Manufacturing, Youth Education, Healthy Aging Society, and Real Estate Boom. Participants exchanged views on sectors such as finance, digital economy, new energy, technology, education, and healthcare, jointly exploring the future development of China-UAE economic cooperation and double-bay (Guangdong-Hong Kong-Macao Greater Bay Area and UAE) economic collaboration. The event served as a crucial platform for global Chinese entrepreneurs to communicate and collaborate, marking a further deepening of economic and cultural cooperation between China and the UAE.</p>
    <p>穆尔亲王，亲自为旅阿30年以上的华侨代表颁发了“庆祝中阿建交40周年，旅阿30年辉煌见证祥云纪念章”，表彰他们在促进中阿友好合作、推动华侨事业发展方面所做出的卓越贡献。此次颁奖仪式成为了活动的高潮之一，展现了中阿两国之间深厚的友谊与合作。<br> Prince Moore personally presented the "Xiangyun Medal for Witnessing 30 Glorious Years in the UAE - Celebrating the 40th Anniversary of the Establishment of Diplomatic Relations between China and the UAE" to the overseas Chinese representatives who have lived in the UAE for over 30 years, in recognition of their outstanding contributions to promoting friendly cooperation between China and the UAE and advancing the cause of overseas Chinese. This award - ceremony became one of the highlights of the event, demonstrating the deep friendship and cooperation between China and the UAE.</p>
    <p>世界华商周（迪拜）暨第二届双湾论坛在众人的瞩目中圆满成功，完美落幕。<br>The World Chinese Entrepreneurs Week (Dubai) and the 2nd Double Bay Forum successfully concluded amid widespread attention, marking a perfect ending.</p>
    <img src="@/assets/img/article/1.webp" alt="">
    <p class="img-alt">香港晴天集团董事局主席洪子晴爵士赠送礼品给阿联酋迪拜重要王室成员谢赫·穆尔亲王</p>
    <p class="img-alt-content">Lady Athena Hung, Chairman of the Board of  HCC Group Ltd. Present a gift to His Highness Prince Sheikh Maktoum bin Rashid Al Maktoum, an important member of the Dubai Royal Family in the United Arab Emirates.</p>
    <img src="@/assets/img/article/5.jpg" alt="">
    <p class="img-alt">香港晴天集团董事局主席洪子晴爵士与中国全国政协常委、香港中华总商会会长蔡冠深先生合影</p>
    <p class="img-alt-content">Lady Athena Hung,Chairman of the Board of  HCC Group with Mr. Jonathan Choi Koon-shum, Member of the Standing Committee of the National Committee of the Chinese People's Political Consultative Conference (CPPCC) and President of the Chinese General Chamber of Commerce, Hong Kong.</p>
    <img src="@/assets/img/article/6.jpg" alt="">
    <p class="img-alt">香港晴天集团董事局主席洪子晴爵士与Mr.Marwan Janahi 迪拜科技园董事总经理、迪拜工业战略药品和医疗设备工作组主席经验分享</p>
    <p class="img-alt-content">Lady Athena Hung, Chairman of the Board of HCC Group Ltd. Experience Sharing with Mr. Marwan Janahi, Managing Director of Dubai Science Park and Chairman of the Pharmaceutical and Medical Equipment Taskforce of the Dubai Industrial Strategy.</p>
    <img src="@/assets/img/article/7.jpg" alt="">
    <p class="img-alt">香港晴天集团董事局主席洪子晴爵士发表顺势疗法的发展与未来</p>
    <p class="img-alt-content">Lady Athena Hung, Chairman of the Board of HCC Group Ltd.Deliver a speech on the development and future of homeopathy.</p>
    <img src="@/assets/img/article/8.jpg" alt="">
    <p class="img-alt">香港晴天集团有限公司董事局主席与嘉宾分享顺势疗法的发展与未来</p>
    <p class="img-alt-content">Lady Athena Hung, Chairman of the Board of HCC Group Ltd. Share the development and future of homeopathy with guests.</p>
    <img src="@/assets/img/article/9.jpg" alt="">
    <p class="img-alt">全国政协常委、香港中华总商会主席蔡冠深博士发表讲话</p>
    <p class="img-alt-content">Dr. Koon Shum Choi, a member of the Standing Committee of the National Committee of the Chinese People's Political Consultative Conference and the Chairman of the Hong Kong Chinese General Chamber of Commerce, delivered a speech.</p>
    <img src="@/assets/img/article/10.jpg" alt="">
    <p class="img-alt">全国政协常委、香港中华总商会主席蔡冠深博士发表讲话</p>
    <p class="img-alt-content">Dr. Koon Shum Choi, a member of the Standing Committee of the National Committee of the Chinese People's Political Consultative Conference and the Chairman of the Hong Kong Chinese General Chamber of Commerce, delivered a speech.</p>
    <img src="@/assets/img/article/11.jpg" alt="">
    <p class="img-alt">张益明大使在迪拜世界华商周闭幕式上讲话</p>
    <p class="img-alt-content">Speech by H.E. Zhang Yimingat the Closing Ceremony of the World Chinese Entrepreneurs Week</p>
  </div>
</template>

<script>
export default {
  name: '1',
  components: {},
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.article{
  width: 70%;
  margin: 20px auto;
  font-family: $font-family;
  .title{
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
  }

  .info{
    height: 28px;
    line-height: 28px;
    border-bottom: 1px #e8e8e8 solid;
    margin: 0;
    text-align: center;
    font-size: 0.8rem;
  }

  p{
    font-size: $content-font-size;
    color: #000000;
    line-height: 2;
    margin: 20px 0;
  }

  img{
    width: 60%;
    margin-left: 20%;
  }

  .img-alt{
    text-align: center;
    line-height: 1;
    margin: 6px 0;
    padding-top: 10px;
    color: #2f2e2e;
    font-size: 0.9rem;
  }

  .img-alt-content{
    text-align: center;
    line-height: 1;
    margin: 6px 0;
    padding-top: 5px;
    padding-bottom: 15px;
    color: #2f2e2e;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .article{
    width: 90%;
    margin: 20px auto;
    .title{
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $phone-content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 80%;
      margin-left: 10%;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      color: #2f2e2e;
      padding-top: 5px;
      font-size: 0.8rem;
    }
    .img-alt-content{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 5px;
      padding-bottom: 15px;
      color: #2f2e2e;
      font-size: 0.8rem;
    }
  }
}

@media (max-width: 480px) {
  .article{
    width: 100vw;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 20px auto;
    .title{
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: 1rem;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 100%;
      margin: 0;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      font-size: 0.7rem;
      margin: 6px 0;
      color: #666;
    }
  }
}
</style>
